import $ from 'jquery';

$(function() {

  var $btn = $('.scroll-top');

  if ($btn.length > 0) {
    var $window = $(window),
        $body = $('body'),
        offset = $window.height();

    checkPosition($body);

    $window.scroll(function() {
      checkPosition($body);
    });
  }

  function checkPosition() {
    var scrollTop = $window.scrollTop(),
        offset = $window.height();

    if (scrollTop > offset) {
      $btn.css('visibility', 'visible')
          .addClass('is-visible');
    } else {
      $btn.removeClass('is-visible')
          .css('visibility', 'hidden');
    }
  }

});
